import React from 'react'
import ConditionalWrap from 'conditional-wrap'

interface ConditionalWrapperProps {
  condition: boolean
  wrapper: (children: React.ReactElement) => React.ReactElement
  children: React.ReactElement
}

const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({ condition, wrapper, children }) => (
  <ConditionalWrap condition={condition} wrap={wrapper}>
    {children}
  </ConditionalWrap>
)

export default ConditionalWrapper

